import { Pagination, Table } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { StaffEntitySearchContainerEntityResultFieldsFragment } from '../../../../generated';
import { Country } from '../../../../types/country';

interface PaginationComponentProps {
  current: number;
  pageSize: number;
  total: number;
  onChange: (page: number, size?: number) => void;
}

const PaginationComponent: React.FC<PaginationComponentProps> = (props) => {
  return (
    <Pagination
      current={props.current}
      pageSize={props.pageSize}
      total={props.total}
      onChange={props.onChange}
      onShowSizeChange={props.onChange}
      showTotal={(total) => `Count: ${total} entities`}
      showSizeChanger
      className="rounded-[10px] p-[15px] border border-[#f0f0f0] my-3"
    />
  );
};

interface EntitySearchTableProps {
  data: StaffEntitySearchContainerEntityResultFieldsFragment[];
  countryData: Country[];
  resultCount: number;
}

export const EntitySearchTable: React.FC<EntitySearchTableProps> = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  const handlePaginationChange = (page: number, size?: number) => {
    const newSize = size || pageSize;
    setCurrentPage(page);
    setPageSize(newSize);
    searchParams.set('page', page.toString());
    searchParams.set('pageSize', newSize.toString());
    setSearchParams(searchParams);
  };

  const countryLookup = useMemo(
    () =>
      props.countryData?.reduce((acc, country) => {
        acc[country.countryCode] = country.countryName;
        return acc;
      }, {} as Record<string, string>),
    [props.countryData]
  );

  const getCountryName = useCallback((countryCode: string) => countryLookup?.[countryCode] || ' ', [countryLookup]);

  const columns = [
    {
      title: 'Entity',
      dataIndex: 'entityName',
      key: 'entityName',

      render: (text: any, record: any) => (
        <Link to={`detail/${record.id}`}>
          {text}
        </Link>
      ),
      type: 'link'
    },
    {
      title: 'City',
      dataIndex: 'city',
      key: 'city',
      type: 'text'
    },
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country',
      render: (_text: any, record: any) => getCountryName(record.country),
      type: 'text'
    }
  ];

  useEffect(() => {
    const page = parseInt(searchParams.get('page') || '1', 10);
    const size = parseInt(searchParams.get('pageSize') || '10', 10);

    setCurrentPage(page);
    setPageSize(size);
  }, [searchParams]);

  return (
    <div className="flex flex-col w-full pt-[2px]">
      <PaginationComponent current={currentPage} pageSize={pageSize} total={props.resultCount} onChange={handlePaginationChange} />
      <Table className="w-full border border-[#f0f0f0] rounded-[10px] p-[15px] max-w-full border-solid" scroll={{x: 'max-content'}} columns={columns} dataSource={props.data} rowKey="id" pagination={false} rowHoverable={false}/>
      <PaginationComponent current={currentPage} pageSize={pageSize} total={props.resultCount} onChange={handlePaginationChange} />
    </div>
  );
};
